import { AppBar } from '@mui/material'
import Grid from '@config/Grid/Grid'
import { useLocation } from 'react-router-dom'
import { headerStyles } from './Header.styles'
import Breadcrumbs from '../BreadCrumbs/BreadCrumbs'
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch'
import IconButton from '../IconButton/IconButton'
import { useMenuSidebarStore } from '@/shared/store/useMenuSidebarStore'
import { useEmployeeRankingStore } from '@/shared/store/useEmployeeRankingStore'
import { useFloorPlanPanelStore } from '@/shared/store/useFloorPlanPanelStore'
import styles from './Header.module.scss'

function Header() {
  const { setIsOpen, isOpen } = useMenuSidebarStore()
  const { setIsOpen: setRankingOpen, isOpen: isRankingOpen } =
    useEmployeeRankingStore()
  const { setIsOpen: setEditorOpen, isOpen: isEditorOpen } =
    useFloorPlanPanelStore()
  const location = useLocation()

  return (
    <AppBar position="fixed" sx={headerStyles}>
      <Grid>
        <div className={`start-2 col-12 align-center ${styles.headerWrapper}`}>
          <Breadcrumbs />
          <div className={styles.headerRightSidePanel}>
            {location.pathname.includes('/menu-management') && (
              <div id="tour-menu-sub-nav">
                <IconButton
                  icon="las la-cog"
                  onClick={() => setIsOpen(!isOpen)}
                  color={isOpen ? 'secondary' : 'primary'}
                  variant="contained"
                />
              </div>
            )}
            {location.pathname.includes('/employees-management') && (
              <div id="tour-ranking-button">
                <IconButton
                  icon="las la-medal"
                  onClick={() => setRankingOpen(!isRankingOpen)}
                  color={isRankingOpen ? 'secondary' : 'primary'}
                  variant="contained"
                />
              </div>
            )}
            {location.pathname.includes('/floor-plan') && (
              <div id="tour-floor-plan-panel-toggle">
                <IconButton
                  icon="las la-sliders-h"
                  onClick={() => setEditorOpen(!isEditorOpen)}
                  color={isEditorOpen ? 'secondary' : 'primary'}
                  variant="contained"
                />
              </div>
            )}

            <LanguageSwitch />
          </div>
        </div>
      </Grid>
    </AppBar>
  )
}

export default Header
